import { H3 } from "../../../../AbstractElements";
import { JavascriptSourcedDataHeading, JavascriptSourcedSpan1, JavascriptSourcedSpan2 } from "../../../../Constant";

const JavaScriptSourcedDataHeader = () => {
  return (
    <div className="card-header pb-0 card-no-border">
      <H3 className="mb-3">{JavascriptSourcedDataHeading}</H3>
      <span dangerouslySetInnerHTML={{ __html: JavascriptSourcedSpan1 }} />
      <span dangerouslySetInnerHTML={{ __html: JavascriptSourcedSpan2 }} />
    </div>
  );
};
export default JavaScriptSourcedDataHeader;
